/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { GameLoginType } from './enums';
import { Encrypt } from './base.models';

export class GamePrivateLoginRequest {
	public _type: GameLoginType;
	@Encrypt()
	public password: string;
	public name: string;

	constructor(values: GamePrivateLoginRequest) {
		for (const [key, value] of Object.entries(values)) this[key] = value;
	}
}
